// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginButton_button__1x2Kt","iconWrapper":"LoginButton_iconWrapper__2Ac7e","title":"LoginButton_title__2e4WO"};